import { EventEmitter } from 'events';
import { isTokenExpired } from './jwtHelper';
import { browserHistory } from 'react-router';
import auth0 from 'auth0-js';
import Users from '../api/Users';

export default class AuthService extends EventEmitter {
  constructor(clientId, domain) {
    super()
    // Configure Auth0
    this.auth0 = new auth0.WebAuth({
      clientID: clientId,
      domain: domain,
      responseType: 'token id_token',
      redirectUri: `${window.location.origin}/signin`
    })

    this.login = this.login.bind(this)
    this.signup = this.signup.bind(this)
    this.loginWithGoogle = this.loginWithGoogle.bind(this)
  }

  login(username, password) {
    this.auth0.client.login({
      realm: 'Username-Password-Authentication',
      username,
      password
    }, (err, authResult) => {
      if (err) {
        alert('Something went wrong while logging in: ' + err.description);
        return
      }
      if (authResult && authResult.idToken && authResult.accessToken) {
        // set the profile for the user
        this.auth0.client.userInfo(authResult.accessToken, (error, profile) => {
          if (error) {
            console.log('Error loading user profile', error);
          } else {
            // We'll need to check in the MongoDb to see if this user exists
            Users.findUser(profile.sub, (users) => {
              // create a new user if one can't be found
              if (!users.length) {
                Users.createUser(profile.sub);
              }
            });

            this.setProfile(profile);
          }
        });
        this.setToken(authResult.accessToken, authResult.idToken)
        browserHistory.replace('/home');
      }
    })
  }

  signup(email, password){
    this.auth0.redirect.signupAndLogin({
      connection: 'Username-Password-Authentication',
      email,
      password,
    }, function(err) {
      if (err) {
        alert('Something went wrong with sign up: ' + err.description);
        return
      }
    })
  }

  loginWithGoogle() {
    this.auth0.authorize({
      connection: 'google-oauth2'
    });
  }

  // apparently this gets called for every Auth0 sign in
  parseHash(hash) {
    this.auth0.parseHash({ hash }, (err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setToken(authResult.accessToken, authResult.idToken)
        this.auth0.client.userInfo(authResult.accessToken, (error, profile) => {
          if (error) {
            console.log('Error loading profile', error);
          } else {
            // We'll need to check in the MongoDb to see if this user exists
            Users.findUser((user) => {
              // create a new user if one can't be found
              if (!user.length) {
                Users.createUser(profile);
              }
            });

            // set the local profile for current user
            this.setProfile(profile);

            // go to the team page for this user
            if (profile && profile.team && profile.team.domain)
              browserHistory.replace('/' + profile.team.domain);
            else browserHistory.replace('/');
          }
        });
      } else if (authResult && authResult.error) {
        alert('Something went wrong: ' + authResult.error)
      }
    })
  }

  loggedIn() {
    // Checks if there is a saved token and it's still valid
    const token = this.getToken()
    return !!token && !isTokenExpired(token)
  }

  setToken(accessToken, idToken) {
    // Saves user access token and ID token into local storage
    localStorage.setItem('access_token', accessToken)
    localStorage.setItem('id_token', idToken)
  }

  setProfile(profile) {
    // Saves profile data to localStorage
    localStorage.setItem('profile', JSON.stringify(profile))
    // Triggers profile_updated event to update the UI
    this.emit('profile_updated', profile)
  }

  getProfile() {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem('profile')
    return profile ? JSON.parse(localStorage.profile) : {}
  }

  getUserTeam() {
    const profile = this.getProfile();
    if (profile && profile.team && profile.team.domain) {
      return profile.team.domain
    }
    else return undefined;
  }

  getUserId() {
    const profile = this.getProfile();
    if (profile && profile.slack_id) {
      return profile.slack_id;
    }
    else return undefined;
  }

  getToken() {
    // Retrieves the user token from localStorage
    return localStorage.getItem('id_token')
  }

  logout() {
    // Clear user token and profile data from localStorage
    localStorage.removeItem('id_token')
    localStorage.removeItem('profile')
    browserHistory.replace('/');
  }
}



// WEBPACK FOOTER //
// ./src/utils/AuthService.js